import angular, { ILogService } from 'angular'
import { $candidatoMod } from 'src/_candidato/priv/candidato-mod'
import { CandidatoConfig } from '../../../_test/play-candidato-app'

import './if-dev.scss'

class IfDevComponentCtrl {
  clazz!: string | undefined
  debug: boolean
  toggle: boolean

  show: boolean

  constructor(private $log: ILogService, private $element: JQLite, private CandidatoCfg: CandidatoConfig) {}

  $onInit(): void {
    this.show = (this.toggle && this.CandidatoCfg.debugforce) || this.CandidatoCfg.debug
    this.show = this.CandidatoCfg.debugforce || this.CandidatoCfg.debug

    this.$log.info('[IfDevComponentCtrl] onInit', this.show, this.clazz)

    if (this.clazz) {
      this.$element.addClass(this.clazz)
    }

    if (!this.show) this.$element.remove()
  }
}

angular.module('candidato').component('ifDev', {
  bindings: {
    // empresa: "<",
    toggle: '<',
    clazz: '@',
  },
  controllerAs: 'ctrl',
  transclude: true,
  controller: IfDevComponentCtrl,
  template: `<span class="if__dev" ng-if="::ctrl.show" ng-transclude></span>`,
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/if-dev/if-dev.component.html"
})
